const startMonth = 12; // December
const startDay = 1;
const endMonth = 1; // January
const endDay = 31;

export function isXmas() {
  const date = new Date();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const start = startMonth * 100 + startDay;
  const end = endMonth * 100 + endDay;
  const current = month * 100 + day;

  const inDirectRange = start <= end && current >= start && current <= end;
  const inSplitRange = start > end && (current >= start || current <= end);
  return inDirectRange || inSplitRange;
}
